import Lottie from 'react-lottie';
import custom_loader_sterckx from "../../assets/animations/custom_loader_sterckx.json";

export default function LoadingPage({progress}) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: custom_loader_sterckx,
        rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
        }
    };

	return (
	    <>  
            <div 
                className='flex flex-col items-center justify-center w-dvw h-dvh'
            >
                <Lottie options={defaultOptions} width={100} height={100}/>
                {progress && <p className='mt-2 text-lg text-center text-neutral-400'>{progress}%</p>}
            </div>
	    </>  
  	);
}